import LoaderWheel from "../LoaderWheel";
import { useContext, useEffect, useState } from "react";
import { AppContext } from '../../utils/ContextProvider';
import API from "../../utils/API";
import Swal from 'sweetalert2';
import GlobalSVG from "../../utils/GlobalSVG";
import moment from 'moment';
import AlertsMultipleSelect from "../AlertsMultipleSelect";
import { Link } from "react-router-dom";
import { uploadAndScan } from "../../utils/utils";

const MaintenanceLogLine = (props) => {
    const context = useContext(AppContext);
    const [deleting, setDeleting] = useState(false)
    const [saving, setSaving] = useState(false)
    const [log, setLog] = useState({})
    const [loading, setLoading] = useState(false)
    const [photos, setPhotos] = useState([])
    const [magnify, setMagnify] = useState(false)
    const [edit, setEdit] = useState(false)
    const statusColor = { 'Upcoming': '#007b4e', 'Due': '#F9941E', 'Set': '#B8BBB9', 'Overdue': '#F75D5F' }
    const [showNote, setShowNote] = useState(false)


    useEffect(() => {
        if (props.adding) setEdit(true)
        if (!props.log || Object.keys(props.log).length === 0) return
        setLog(props.log)
    }, [props.log, props.adding])

    useEffect(() => {
        if (!edit || log.completed_date) return
        updateLog({ target: { name: "completed_date", value: moment().format("YYYY-MM-DDTHH:mm") } })
    }, [edit, log])

    const handleSave = () => {
        const save = async () => {
            let groupId
            if (!log.channel_id && !log.type && !props.selectedPoints.length) {
                let text = 'Please select an activity then try saving again!'
                if (!log.channel_id) text = 'Please select an equipment then try saving again!'
                Swal.fire({
                    title: 'Oops!',
                    text: text,
                    icon: 'warning',
                    confirmButtonText: 'Ok',
                    confirmButtonColor: '#007b4e',
                });
                setSaving(false)
                return
            } else {
                let logList = []
                let tempLog = structuredClone(log)
                if (props.equipmentList) {
                    if (props.selectedPoints) {
                        groupId = props.group.id
                        for (let item of props.selectedPoints) {
                            tempLog.channel_name = props.equipmentList[item].channel_name
                            tempLog.activity_id = props.equipmentList[item].id
                            tempLog.threshold_hours = props.equipmentList[item].threshold_hours
                            tempLog.threshold_days = props.equipmentList[item].threshold_days
                            tempLog.tolerance_hours = props.equipmentList[item].tolerance_hours
                            tempLog.tolerance_days = props.equipmentList[item].tolerance_days
                            tempLog.timebase = props.equipmentList[item].timebase
                            tempLog.channel_id = item
                            logList.push(structuredClone(tempLog))
                        }
                    } else {
                        tempLog.channel_name = props.equipmentList[tempLog.channel_id].channel_name
                        tempLog.activity_id = props.equipmentList[tempLog.channel_id].id
                        tempLog.threshold_hours = props.equipmentList[tempLog.channel_id].threshold_hours
                        tempLog.threshold_days = props.equipmentList[tempLog.channel_id].threshold_days
                        tempLog.tolerance_hours = props.equipmentList[tempLog.channel_id].tolerance_hours
                        tempLog.tolerance_days = props.equipmentList[tempLog.channel_id].tolerance_days
                        tempLog.timebase = props.equipmentList[tempLog.channel_id].timebase
                        logList.push(structuredClone(tempLog))
                    }
                } else {
                    tempLog.channel_name = props.groupsList[tempLog.type].channel_name
                    tempLog.activity_id = props.groupsList[tempLog.type].id
                    tempLog.threshold_hours = props.groupsList[tempLog.type].threshold_hours
                    tempLog.threshold_days = props.groupsList[tempLog.type].threshold_days
                    tempLog.tolerance_hours = props.groupsList[tempLog.type].tolerance_hours
                    tempLog.tolerance_days = props.groupsList[tempLog.type].tolerance_days
                    tempLog.timebase = props.groupsList[tempLog.type].timebase
                    logList.push(structuredClone(tempLog))
                    groupId = props.groupsList[tempLog.type].group_id
                }
                if (props.adding) {
                    for (let log of logList) {
                        try {
                            let res = await API.createMaintenanceLog(log)
                            let tempGroups = structuredClone(props.groups)
                            let updatedGroups = tempGroups.map(e => {
                                if (e.id === groupId) {
                                    let logs = [...e.logs] || []
                                    logs.push(res.data)
                                    return { ...e, logs: structuredClone(logs) }
                                }
                                return e;
                            });
                            props.setGroups(updatedGroups);
                            props.updateNumbers(updatedGroups)
                            setEdit(false)
                            props.setAdding(false)
                        } catch (e) {
                            console.log(e)
                            Swal.fire({
                                title: 'Oops!',
                                text: 'An error occurred, please try again later.',
                                icon: 'warning',
                                confirmButtonText: 'Ok',
                                confirmButtonColor: '#007b4e',
                            });
                        }
                    }
                    setSaving(false)
                } else {
                    let group_id = log.group_id
                    let forbidden = ["id", "updated_by", "created_at", "updated_at", "activity_id", "runtime", "daysOverdue", "onTime", "channel_name", "percent", "group_id", "type", "channel_id"]
                    let payload = structuredClone(log)
                    for (let key in payload) {
                        if (forbidden.includes(key)) delete payload[key]
                    }
                    payload['completed_date'] = moment(payload['completed_date']).format("YYYY-MM-DD HH:MM:SS")
                    API.updateMaintenanceLog(payload, log.id).then(async res => {
                        let tempGroups = structuredClone(props.groups)
                        let updatedGroups = tempGroups.map(e => {
                            if (e.id === group_id) {
                                let logs = e.logs.filter(e => e.id !== log.id)
                                logs.push(log)
                                return { ...e, logs: JSON.parse(JSON.stringify(logs)) };
                            }
                            else return e
                        });
                        props.setGroups(updatedGroups);
                        props.updateNumbers(updatedGroups)
                        setEdit(false)
                    }).catch(e => {
                        console.log(e)
                        Swal.fire({
                            title: 'Oops!',
                            text: 'An error occurred, please try again later.',
                            icon: 'warning',
                            confirmButtonText: 'Ok',
                            confirmButtonColor: '#007b4e',
                        });
                    }).finally(f => {
                        setSaving(false)
                    })
                }
            }
        }

        setSaving(true)
        if (props.group.logs.find(e => e.channel_id === parseInt(log.channel_id) && e.completed_date && e.completed_date.split("T")[0] === log.completed_date.split(" ")[0])) {
            Swal.fire({
                title: 'Potential Duplicate',
                text: 'A log with the same timestamp was added to for this activity, are you sure you want to continue?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, save!',
                cancelButtonText: 'No, cancel!',
                reverseButtons: true
            }).then(async (result) => {
                if (!result.isConfirmed) {
                    setSaving(false)
                    return
                } else {
                    save()
                }
            });
        } else {
            save()
        }
    }

    const updateLog = async (event) => {
        let { name, value, files } = event.target;

        if (name === 'completed_date') {
            value = moment(value).format('YYYY-MM-DD HH:mm:ss')
        }

        if (name === 'images') {
            const selectedImages = await Promise.all(
                Array.from(files).map(file =>
                    new Promise((resolve) => {
                        const reader = new FileReader();
                        reader.onload = (e) => resolve({
                            name: file.name,
                            type: file.type,
                            size: file.size,
                            data: e.target.result
                        });
                        reader.readAsDataURL(file);
                    })
                )
            );
            if (selectedImages && selectedImages.length > 0) {
                setSaving(true);
                let uploadedUrls = await uploadAndScan(selectedImages)

                setLog((prev) => ({
                    ...prev,
                    images: [...(prev.images ?? []), ...uploadedUrls],
                }));

                setSaving(false);
            }
            return
        }
        // For all other fields
        setLog(prev => ({ ...prev, [name]: value }));
    };

    useEffect(() => {
        if (showNote && log.id) {
            setLoading(true)
            const cancelToken = API.cancelToken();
            API.getMaintenancePhotos(cancelToken, log.id).then(res => {
                setPhotos(res.data)
            }).catch(err => {
                console.log(err)
                if (err.message === 'cancelling') return
                let message = 'Please try again later.'
                if (err.response && err.response.data && err.response.data.includes('error')) {
                    message = err.response.data.error
                }
                Swal.fire({
                    title: 'Error.',
                    text: message,
                    icon: 'warning',
                    confirmButtonText: 'Ok',
                    confirmButtonColor: '#007b4e',
                });
            }).finally(f => {
                setLoading(false)
            })

        }
    }, [showNote, log.id])

    const handleDelete = (id) => {

        setDeleting(true)
        Swal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to revert this!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
            reverseButtons: true
        }).then((result) => {
            if (result.isConfirmed) {
                API.updateMaintenanceLog({ deleted: true }, id).then(async res => {
                    let tempGroups = JSON.parse(JSON.stringify(props.groups))
                    let updatedGroups = tempGroups.map(e => {
                        if (e.id === log.group_id) {
                            let logs = e.logs.filter(e => e.id !== log.id)
                            return { ...e, logs: JSON.parse(JSON.stringify(logs)) };
                        }
                        else return e
                    });
                    props.setGroups(updatedGroups);
                    props.updateNumbers(updatedGroups)
                }).catch(e => {
                    console.log(e)
                    Swal.fire({
                        title: 'Oops!',
                        text: 'An error occurred, please try again later.',
                        icon: 'warning',
                        confirmButtonText: 'Ok',
                        confirmButtonColor: '#007b4e',
                    });
                })
            } else {
                setDeleting(false)
            }
        });
    }

    const selectPoints = (event) => {
        if (event.target.value === 'all') props.setSelectedPoints(Object.keys(props.equipmentList).map(e => parseInt(e)))
        else if (event.target.value === 'none') props.setSelectedPoints([])
        else props.setSelectedPoints(prev => prev.includes(event.target.value) ? prev.filter(e => e !== event.target.value) : [...prev, event.target.value])
    }

    const magnifyImage = (url) => {
        setMagnify(url)
    }

    return (
        <div>
            {magnify &&
                <div className="highest-z fixed w-screen h-screen left-0 top-0 flex flex-nowrap justify-center items-center" onClick={() => setMagnify(false)}>
                    <img onClick={() => setMagnify(false)} className='nav-magnified-image' src={magnify} alt="" />
                </div>
            }
            {
                !edit && showNote &&
                <div className="absolute top-[25vh] left-[25vw] w-[50vw] h-[50vh] z1000 overflow-auto bg-[#f9f9f9] p-[15px] rounded card">
                    <div className="w-full flex flex-nowrap justify-end cursor-pointer">
                        <div onClick={() => setShowNote(false)}>
                            {GlobalSVG.close('black')}
                        </div>
                    </div>
                    {
                        <div className='flex flex-wrap'>
                            {
                                loading ?
                                    <LoaderWheel />
                                    :
                                    <div className='input-border flex flex-wrap w-full items-center pt-3 pb-3 mb-6'>
                                        {photos.map((e, idx) => (
                                            <div className='relative'>
                                                <img className='w-16 h-16 m-2' key={e + 'image'} src={e} alt="" onClick={() => magnifyImage(e ? e : require('../../assets/images/placeholder-image.png'))} />
                                            </div>
                                        ))}
                                    </div>
                            }
                        </div>
                    }
                    <div className="text-[#b9b9b9] overflow-auto">
                        {log.notes ? log.notes : "No notes."}
                    </div>
                </div>
            }
            {log &&
                <div style={{ color: statusColor[log.status] }} className='flex flex-nowrap justify-between items-center py-4 my-2 w-full border-b border-1 border-[#B8BBB9] relative'>

                    {
                        !edit && context.getBuildingInfo &&
                        <Link to={`/distribution?building=${context.getBuildingInfo.building_id}&origin=maintenance&start=${moment(log.completed_date).format('YYYY-MM-DD')}&end=${moment(log.completed_date).format('YYYY-MM-DD')}&channel=${log.channel_id}&type=0`} target="_blank">
                            <div className={`underline w-[130px] text-[12px]`}>{log.completed_date ? moment(log.completed_date).format('MMM D, YYYY h:mma') : " - "}</div>
                        </Link>
                    }
                    {edit && <input
                        type="datetime-local"
                        name="completed_date"
                        disabled={!edit}
                        max={moment().format("YYYY-MM-DDTHH:mm")}
                        className={`w-[130px] text-[12px] ${!edit ? "bg-[transparent]" : "bg-[#ededed]"}`}
                        defaultValue={edit ? (log.completed_date ? moment(log.completed_date).format("YYYY-MM-DDTHH:mm") : moment().format("YYYY-MM-DDTHH:mm")) : log.completed_date ? moment(log.completed_date).format("YYYY-MM-DDTHH:mm") : ""}
                        onChange={updateLog} />}
                    {props.adding &&
                        props.equipmentList &&
                        <AlertsMultipleSelect
                            idAttr='channel_id'
                            valAttr='channel_name'
                            data={Object.values(props.equipmentList)}
                            dataType='circuits'
                            selectItem={selectPoints}
                            selectedList={props.selectedPoints}
                            placeholder="Select"
                            deselectAll={true} />
                    }
                    {!props.adding &&
                        props.equipmentList && <select
                            onChange={updateLog}
                            className={`w-[150px] text-[12px] overflow-hidden overflow-ellipsis whitespace-nowrap ${!edit ? "bg-[transparent]" : "bg-[#ededed]"}`}
                            disabled={!edit}
                            name="channel_id"
                            value={log.channel_id && log.channel_id}>
                            <option value=""> - </option>
                            {
                                Object.keys(props.equipmentList).map((e, id) => (
                                    <option key={id + e} value={e}>{props.equipmentList[e].channel_name}</option>
                                ))
                            }
                        </select>}
                    {props.groupsList && <select
                        onChange={updateLog}
                        className={`w-[100px] text-[12px] overflow-hidden overflow-ellipsis whitespace-nowrap ${!edit ? "bg-[transparent]" : "bg-[#ededed]"}`}
                        disabled={!edit}
                        name="type"
                        value={log.type && log.type}>
                        <option value=""> - </option>
                        {
                            Object.keys(props.groupsList).map((e, id) => (
                                <option key={id + e} value={e}>{e}</option>
                            ))
                        }
                    </select>}
                    <div className="text-[12px] w-[130px] outline-none">{log.threshold_hours ? log.threshold_hours + "+/-" : " - "}{log.tolerance_hours ? log.tolerance_hours : ""} h</div>
                    <div className="text-[12px] w-[130px] outline-none">{log.threshold_days ? log.threshold_days + "+/-" : " - "}{log.tolerance_days ? log.tolerance_days : ""} days</div>
                    {/* <div className="text-[12px] w-[60px] outline-none">{log.tolerance ? log.tolerance : " - "}{log.timebase === 'runtime' ? "h" : " days"}</div> */}
                    <div className="text-[12px] w-[130px] outline-none">{log.runtime ? parseInt(log.runtime).toLocaleString() : " - "}{log.actualTimebase === 'runtime' ? "h" : " days"}</div>
                    <div className={`w-[70px] text-[12px] ${log.daysOverdue || log.daysOverdue === 0 ? "" : "pl-[25px]"}`}>{log.daysOverdue || log.daysOverdue === 0 ? parseInt(log.daysOverdue).toLocaleString() + (log.actualTimebase === 'runtime' ? "h" : " days") : " - "}</div>
                    {/* <div className={`w-[110px] text-[12px] ${log.percent || log.percent === 0 ? "" : "pl-[25px]"}`}>{log.percent || log.percent === 0 ? parseInt(log.percent * 100).toLocaleString() + "%" : " - "}</div> */}
                    <input
                        type="text"
                        name="performed_by"
                        disabled={!edit}
                        className={`w-[100px] text-[12px] ${!edit ? "bg-[transparent]" : "bg-[#ededed]"}`}
                        defaultValue={log.performed_by ? log.performed_by : ""}
                        onChange={updateLog} />
                    {/* <div className={`w-1/12 text-[12px] ${log.updated_at ? "" : "pl-[25px]"}`}>{log.updated_at ? moment(log.updated_at).format('YYYY-MM-DD') : " - "}</div> */}
                    <div className={`w-1/12 text-[12px] ${log.updated_by ? "" : "pl-[25px]"}`}>{log.updated_by ? log.updated_by : " - "}</div>
                    <div className="">
                        <div className="flex flex-nowrap justify-end items-center">
                            {edit &&
                                (saving ?
                                    <LoaderWheel /> :
                                    <div className="py-[2px] px-2 bg-[#007b4e] text-[white] text-[10px] rounded-[4px] mr-[12px] cursor-pointer" onClick={handleSave}>Save</div>)
                            }
                            {
                                !edit &&
                                <div className='cursor-pointer w-[21px] mr-[4px]' >
                                    <div onClick={() => setShowNote(true)}>{GlobalSVG.info('black')}</div>
                                </div>
                            }
                            {
                                !edit &&
                                <div className='cursor-pointer w-[25px]' onClick={() => setEdit(true)}>
                                    {context.getUserInfo && context.getUserInfo.manage_maintenance_logs && GlobalSVG.edit('black')}
                                </div>
                            }
                            {
                                !edit &&
                                <div className='cursor-pointer w-[25px]'>
                                    {context.getUserInfo && context.getUserInfo.manage_maintenance_logs &&
                                        (deleting ?
                                            <LoaderWheel /> :
                                            <div className='cursor-pointer w-[15px] h-[18px]' onClick={() => handleDelete(log.id)}>{GlobalSVG.delete()}</div>)
                                    }
                                </div>
                            }
                        </div>

                    </div>

                </div>}
            {
                edit && <div className='flex flex-wrap'>
                    <div className='input-border flex flex-wrap w-full items-center pt-3 pb-3 mb-6'>
                        <label className='w-1/12 text-base input-label-color'>Images</label>
                        <div className='w-10/12 flex flex-wrap items-center'>

                            {edit &&
                                <input
                                    className='mobile:w-full tablet:w-7/12 mr-2 text-base input-color p-2 outline-none hide-input-background'
                                    type="file"
                                    name="images"
                                    multiple
                                    onChange={updateLog} />
                            }
                        </div>
                    </div>
                </div>
            }
            {
                edit &&
                <textarea
                    data-gramm="false"
                    data-gramm_editor="false"
                    data-enable-grammarly="false"
                    type="text"
                    name="notes"
                    disabled={!edit}
                    placeholder="Notes"
                    className="text-sm text-[#332D41] mb-[10px] w-full outline-none hide-input-background p-[10px]"
                    defaultValue={log && log.notes}
                    onChange={updateLog}></textarea>
            }
        </div>
    )
}
export default MaintenanceLogLine